module.exports = __webpack_public_path__ + "img/INF-A-1-II.9f2677b2.png";